import { Injectable, Injector } from '@angular/core';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';

import { OktaPkceAuthService } from './core/services/okta-pkce-auth.service';
import { UserService } from './core/services/user.service';
import { AuthService } from './core/services/auth.service';
import { AuthValidate } from './shared/models/app';
import { TokenService } from './shared/utils/token.service';
import { DataCacheService } from './core/services/data-cache.service';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  /*********************Properties*********************/
  alertLoaded$: Subject<number> = new Subject<number>();
  private _router: Router;
  /*********************Properties*********************/

  /*********************Constructor*********************/
  constructor(
    private authService: AuthService,
    private oktaPkceAuth: OktaPkceAuthService,
    private userService: UserService,
    private token: TokenService,
    private injector: Injector,
    private dataCacheService: DataCacheService
  ) {
    setTimeout(() => this._router = injector.get(Router));
  }
  /*********************Constructor*********************/

  /*********************Utility Methods*********************/

  init() {
    this.oktaPkceAuth.init();
  }

  initOnLoad(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (this.token.getQueryToken() ) {
        resolve(true);
        return;
      }
      this.authService.isAuthenticated().then((response: AuthValidate) => {
        resolve(response.authenticated.all);
      });
    });
  }

  load(): Promise<any> {
    return new Promise((resolve, reject) => {

          this.oktaPkceAuth.auth.validate = false;

          this.userService.init();
          this.authService.onUserProfileLoaded();
          this.dataCacheService.loadApiCacheEntries();
          resolve(true);
    });
  }

  loadUserDetailsAndRoles(): Promise<any> {
    return new Promise((resolve, reject) => {

          this.oktaPkceAuth.auth.validate = false;

          this.userService.initUserDetailsAndUserRole();
          this.authService.onUserProfileLoaded();
          resolve(true);
    });
  }

  
}
